module.exports = __webpack_public_path__ + "static/assets/3c45689bd282c056394dafe468ae16c0.png";